import { all, takeEvery, put } from "redux-saga/effects";
import siteConfig from "@iso/config/site.config";
import actions from "./actions";
import { notification } from "@iso/components";
const gaxios = require("gaxios");
gaxios.instance.defaults = {
  baseURL: siteConfig.siteUrl.API_URL,
};

export function* getPedidosOnline(action) {
  const query = action.query ? `?${action.query}` : "";
  const res = yield gaxios.request({
    url: "api/payU" + query,
  });
  if (!res.data.success) {
    notification("error", "Error al traer la info");
  } else {
    yield put({
      type: actions.GET_PEDIDOS_ONLINE_SUCCESS,
      payload: res.data.pedidosOnline,
    });
    if (res.data.paginationInfo) {
      yield put({
        type: actions.SET_PAGINATION_INFO,
        payload: res.data.paginationInfo,
      });
    }
  }
}

export function* getPedidosByReferenceCode(action) {
  console.log(action);
  const data = {
    test: false,
    language: "es",
    command: "ORDER_DETAIL_BY_REFERENCE_CODE",
    merchant: {
      apiLogin: "9xH10CNjjau3zBy",
      apiKey: "QyA0UiSY8ub7z1NMvedr2WqMqZ",
    },
    details: {
      referenceCode: action.payload,
    },
  };

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  };
  gaxios.instance.defaults = {
    baseURL: '',
  };
  const res = yield gaxios.request({
    url: "https://api.payulatam.com/reports-api/4.0/service.cgi",
    method: "POST",
    data,
    headers,
  });

  yield put({
    type: actions.GET_PEDIDOS_BY_REFERENCE_CODE_SUCCESS,
    payload: res.data,
  });
}

export function* updatePedidosOnline({ payload, query }) {
  console.log("ya aca!!!")
  let res;
  if (
    payload.hasOwnProperty("enProduccion") ||
    payload.hasOwnProperty("anulado")
  ) {
    res = yield gaxios.request({
      url: "api/payU/data/" + payload._id,
      method: "PUT",
      data: payload,
    });
  } else {
    res = yield gaxios.request({
      url: "api/payU/pagos/" + payload._id,
      method: "PUT",
      data: payload,
    });
  }
  if (!res.data.success) {
    notification("error", res.data.msg);
  } else {
    notification("success", res.data.msg);
    yield put({ type: actions.GET_PEDIDOS_ONLINE_REQUEST, query });
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_PEDIDOS_ONLINE_REQUEST, getPedidosOnline),
    yield takeEvery(actions.UPDATE_PEDIDOS_ONLINE, updatePedidosOnline),
    yield takeEvery(
      actions.GET_PEDIDOS_BY_REFERENCE_CODE_REQUEST,
      getPedidosByReferenceCode
    ),
  ]);
}
